import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const ExternalReturnPage = () => {
  const [searchParams] = useSearchParams();
  const txId = searchParams.get('tx_id') || '';
  const result = searchParams.get('result') || 'success';

  useEffect(() => {
    // Redirect to the backend API which will 302 to Winluxor
    const apiUrl = `/api/external/return?tx_id=${encodeURIComponent(txId)}&result=${encodeURIComponent(result)}`;
    window.location.href = apiUrl;
  }, [txId, result]);

  return (
    <div className="bg-[#0a0a0a] min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#2EC866] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 text-sm">Redirecting...</p>
      </div>
    </div>
  );
};

export default ExternalReturnPage;
